import $ from 'jquery';
import Counter from './generic/counter';
import SessionStoragePop from './generic/SessionStoragePop';
import MethodUtils from './generic/methodUtils';
import {MARKET} from 'Utils/market.constants';

/*
// gms - default value
var gmsIntervalTime = 5;
var refreshGmsIntervalId;*/

// selector: "#dcw-gms-zone"


const GMS_DEFAULT_VALUES = {
    URL_SIGNATURE: "/icd/mcd/index-authsec.html",
    URL_NEW_SERVICE: "/icd/mcd/data/nb-messages-authsec.json?b64e200_isRead=false",
    URL_SERVICE : "/gms/gmsInfoServlet",
    SESSION_KEY: "gms_counter",
    MOBILE_BREAKPOINT : 768
}

const GMS_SELECTOR = {
    ID_COUNTER: '#js-counter-gms',
    ID_COUNTER_MOBILE: '#js-counter-gms-mobile'
}

export default class GmsApp {

    constructor() {
        var _self = this;

        _self.counterEmpty = true;

        // init default values
        _self.urlService = GMS_DEFAULT_VALUES.URL_NEW_SERVICE;
        _self.sessionKey = GMS_DEFAULT_VALUES.SESSION_KEY;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new MethodUtils();

        // Init Popin & counter
        _self.counter = new Counter(GMS_SELECTOR.ID_COUNTER);
        if(MARKET.CODE === 1) {
            _self.counterMobile = new Counter(GMS_SELECTOR.ID_COUNTER_MOBILE);
        }

        _self.isInRefreshingMode = true;

        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode)
                _self.updateNotification()
        }, _self.intervalTime);

        _self.updateNotification()
    }

    initPropertiesFromConf() {
        this.intervalTime = window.cmsGlobals.gmsConfig.gmsIntervalTime;

        if (window.cmsGlobals.gmsConfig.urlGmsSignature) {
            this.urlGMSSignature = window.cmsGlobals.gmsConfig.urlGmsSignature;
        } else {
            this.urlGMSSignature = GMS_DEFAULT_VALUES.URL_SIGNATURE;
        }
    }


    launchTimer(data, appliFunction, time) {
        if (data !== null) {
            setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
        }
        return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
    }

    /**
     * Get the value from the session storage, if no value, call Alerting service
     */
    updateNotification() {
        var _self = this;
        if (_self.urlGMSSignature.indexOf(window.location.pathname) !== -1) {
            _self.sessionStoragePop.resetCounterInSession();
            _self.updateDOM();
        } else {
            _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

            if (!_self.dataResponse) {
                _self.callGmsService();
            } else {
                if ( (new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                    _self.updateDOM();
                } else {
                    _self.callGmsService();
                }
            }
        }
    }

    /**
     * Call the service exposed by GMS in order to recover the notification numbers
     */
    callGmsService() {
        var _self = this;

        $.ajax( {
            url:_self.urlService,
            method: "GET",
            swmIntercept: false,
            contentType : "application/xml; charset=utf-8",
            dataType: 'json',
            beforeSend: function(request) {
                request.setRequestHeader("x-no-session-postpone", "true");
            },
            success: function (response) {
                if (response && response.total) {
                    var counter = response.total;

                    // check if counter is well a number
                    if (isNaN(counter)) {
                        _self.sessionStoragePop.removeKey();
                        console.error("Counter not on right format");
                    } else {
                        _self.sessionStoragePop.updateCounterAlone(counter, false);
                        _self.updateDOM();
                    }
                } else {
                    _self.isInRefreshingMode = false;
                    _self.sessionStoragePop.removeKey();
                    console.error("Pas de messages");
                }
            },
            error:  function () {
                _self.isInRefreshingMode = false;
                _self.sessionStoragePop.removeKey();
                console.error("Erreur réseau");
            }
        });
    }

    /**
     * Call the service exposed by GMS in order to recover the notification numbers
     */
    callOldGmsService() {
        var _self = this;

        $.ajax( {
            url:_self.urlService,
            method: "GET",
            swmIntercept: false,
            contentType : "application/xml; charset=utf-8",
            dataType: 'xml',
            beforeSend: function(request) {
                request.setRequestHeader("x-no-session-postpone", "true");
            },
            success: function (response) {
                if (response == undefined
                    || response.firstChild == null
                    || response.firstChild == undefined
                    || response.getElementsByTagName("NbMessage") == null
                    || response.getElementsByTagName("NbMessage")[0].firstChild == null) {
                    clearInterval(_self.intervalTime);
                    _self.sessionStoragePop.removeKey();
                    console.error("Pas de messages");
                } else {
                    var counter = response.getElementsByTagName("NbMessage")[0].firstChild.nodeValue;

                    // check if counter is well a number
                    if (isNaN(counter)) {
                        _self.sessionStoragePop.removeKey();
                        console.error("Counter not on right format");
                    } else {
                        _self.sessionStoragePop.updateCounterAlone(counter, false);
                        _self.updateDOM();
                    }
                }
            },
            error:  function () {
                clearInterval(_self.intervalTime);
                _self.sessionStoragePop.removeKey();
                console.error("Erreur réseau");
            }
        });
    }

    /**
     * Update the html for both counter and infobulle
     */
    updateDOM() {
        var _self = this;
        var data = _self.sessionStoragePop.getJsonObjectFromSession();

        // Update Counter
        _self.counter.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
        if(MARKET.CODE === 1) {
            _self.counterMobile.updateHtml(_self.util.getNotificationCounterToShow(data.counterVal));
        }
    }

}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/gms.js